import React, { useState } from "react";
import { useTranslate, SaveButton } from "react-admin";
import { useFormContext } from "react-hook-form";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import PublishIcon from "@mui/icons-material/Publish";

const commonStyles = {
  icon: {
    fontSize: 22,
  },
  label: {
    display: "inline-block",
    marginLeft: "7px",
  },
};

type TransformFunction = (data: any) => any;

export const RegisterHacobellButton = (props: {
  disabled: boolean;
  transform: TransformFunction;
  isSubmitActionRef: React.MutableRefObject<boolean>;
}) => {
  const { disabled, transform, isSubmitActionRef } = props;
  const [open, setOpen] = useState(false);
  const [agreement, setAgreement] = useState(false);
  const translate = useTranslate();
  const formContext = useFormContext();
  const { setValue } = formContext;

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleDisagree = () => {
    setOpen(false);
  };

  const handleClickAgree = () => {
    setAgreement(!agreement);
  };

  return (
    <>
      <Button variant="contained" color="primary" disabled={disabled} onClick={handleClickOpen}>
        <PublishIcon sx={commonStyles.icon} />
        <Box component="span" sx={commonStyles.label}>
          {translate("ui.individual_deliveries.register_hacobell")}
        </Box>
      </Button>
      <Dialog
        open={open}
        onClose={handleDisagree}
        maxWidth="xl"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{translate("ui.individual_deliveries.register_modal_title")}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <TermOfService />
          </DialogContentText>
          <FormControlLabel
            control={<Checkbox checked={agreement} onChange={handleClickAgree} name="agree" />}
            label={translate("ui.individual_deliveries.check_agree_term")}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDisagree} color="primary">
            {translate("ra.action.cancel")}
          </Button>
          <SaveButton
            label="ui.individual_deliveries.register_hacobell"
            icon={<PublishIcon sx={commonStyles.icon} />}
            type="button"
            transform={transform}
            disabled={!agreement}
            onClick={() => {
              isSubmitActionRef.current = true;
              setValue("status", "waiting_for_arrangement");
              setOpen(false);
            }}
          />
        </DialogActions>
      </Dialog>
    </>
  );
};

const TermOfService = () => {
  return (
    <iframe
      src="/terms/terms_delivery.pdf#view=FitH"
      title="ハコベル利用規約"
      style={{
        width: "80vw",
        height: "50vh",
      }}
    ></iframe>
  );
};
